export const NAMES = {
  TAG_NAME: "ab-progress-bar",
}